import { Check as CheckIcon, Download as DownloadIcon } from "@mui/icons-material";
import { Alert, AlertTitle, Box, Button, Card, CardContent, Typography } from "@mui/material";
import Papa from "papaparse";
import React, { useMemo } from "react";

import {
    formatAppError,
    formatAppErrorType,
    generateDownloadFileName,
    participantConvert,
} from "@bujus/common";

import { CsvDataTable } from "@/base";
import { useSelectedEventStateContext } from "@/contexts";
import { downloadCsvFile } from "@/utilities";

const ParticipantsImportDialog__ReviewStepContent = ({ mutation, onOk }) => {
    const [selectedEvent] = useSelectedEventStateContext();

    const notImportedParticipantCsvRows = useMemo(
        () =>
            mutation.data.fails.map((x) => ({
                ...participantConvert.toCsvRow(
                    selectedEvent.format,
                    mutation.variables.participants.find((y) => y.tempId === x.tempId),
                    { isGroupNameInsteadOfGroup: true },
                ),
                Fehler: formatAppErrorType(x.error.type),
            })),
        [],
    );

    const importedParticipantCsvRows = useMemo(
        () =>
            mutation.data.successes.map((x) =>
                participantConvert.toCsvRow(selectedEvent.format, x.item),
            ),
        [],
    );

    const handleFailsExportingButtonClick = () => {
        downloadCsvFile(
            generateDownloadFileName("Teilnehmer mit Fehlern", "csv"),
            Papa.unparse(notImportedParticipantCsvRows),
        );
    };

    const handleOkButtonClick = () => {
        onOk();
    };

    return (
        <Box>
            {mutation.isError && (
                <Box mb={2}>
                    <Alert>
                        <AlertTitle>{formatAppError(mutation.error)}</AlertTitle>
                    </Alert>
                </Box>
            )}
            {mutation.data.fails.length > 0 && (
                <Box mb={2}>
                    <Card sx={{ borderColor: "error.main" }}>
                        <CardContent>
                            <Box sx={{ position: "relative" }}>
                                <Typography variant="h6">Nicht importierte Teilnehmer</Typography>
                                <Button
                                    onClick={handleFailsExportingButtonClick}
                                    startIcon={<DownloadIcon />}
                                    sx={{
                                        position: "absolute",
                                        right: 0,
                                        top: 0,
                                    }}
                                    variant="outlined"
                                >
                                    Exportieren
                                </Button>
                                <Typography color="text.secondary" mt={2}>
                                    Anzahl: {mutation.data.fails.length}
                                </Typography>
                                <Box mt={2}>
                                    <CsvDataTable csvRows={notImportedParticipantCsvRows} />
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
            )}
            <Card sx={{ borderColor: "success.main" }}>
                <CardContent>
                    <Typography variant="h6">Importierte Teilnehmer</Typography>
                    <Typography color="text.secondary" mt={2}>
                        Anzahl: {mutation.data.successes.length}
                    </Typography>
                    <Box mt={2}>
                        <CsvDataTable csvRows={importedParticipantCsvRows} />
                    </Box>
                </CardContent>
            </Card>
            <Box
                bottom={-20} // Dialog content padding
                display="flex"
                justifyContent="end"
                mt={2}
                position="sticky"
                py={2}
                sx={{
                    backgroundColor: "background.paper",
                    borderColor: "divider",
                    borderTopStyle: "solid",
                    borderTopWidth: 1,
                }}
            >
                <Button onClick={handleOkButtonClick} startIcon={<CheckIcon />}>
                    Ok
                </Button>
            </Box>
        </Box>
    );
};

export { ParticipantsImportDialog__ReviewStepContent };
